<template>
    <staff-message-modal
        :key="messageKey"
        :sender-id="senderId"
        :roles="roles"
        ref="sendAMessage"/>
</template>

<script>
import StaffMessageModal from "../../../modules/Messages/organisms/StaffMessageModal.vue";

export default {
    name: "SendMessage",
    props: {
        senderId: Number,
        selected: Object,
        roles: Array
    },
    data() {
        return {
            messageKey: 0
        }
    },
    components: {
        StaffMessageModal
    },
    methods: {
        init() {
            this.messageKey++;
            this.$nextTick(() => {
                this.$refs.sendAMessage.open();
            });
        }
    },
}
</script>
